var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "modal",
    {
      attrs: {
        name: "select-videos-modal" + _vm.uid,
        width: _vm.$isMobile ? "100%" : "640px",
        height: "520px",
        adaptive: "",
        classes: "overflow-scroll t-modal t-fs--subtitle",
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.resetData },
    },
    [
      _vm.canShowUpload
        ? _c(
            "div",
            { staticClass: "t-config t-mar--l-sm t-mar--t-mi t-mar--b-xs" },
            [
              _c("div", { staticClass: "t-config__body" }, [
                _c("div", { staticClass: "t-config__tabs" }, [
                  _c(
                    "div",
                    {
                      staticClass: "t-config__tab",
                      class: { "t-config__tab--active": _vm.tab == "videos" },
                      on: {
                        click: function ($event) {
                          return _vm.setTab("videos")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("generic.button.trainn_library"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "t-config__tab",
                      class: { "t-config__tab--active": _vm.tab == "upload" },
                      on: {
                        click: function ($event) {
                          return _vm.setTab("upload")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("generic.button.upload_video"))),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "videos"
        ? [
            _c(
              "div",
              {
                staticClass:
                  "t-modal__header t-modal__header--no-border t-pad--all-no",
              },
              [
                _c(
                  "div",
                  { staticClass: "t-width--100" },
                  [_c("search-videos", { attrs: { "hide-label": true } })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-modal__body t-pad--all-no" },
              [
                _c("ListView", {
                  attrs: {
                    "folder-id": _vm.folderId,
                    "to-be-excluded": _vm.toBeExcludedVideos,
                    "selected-videos": _vm.selectedVideos,
                    "loaded-folders": _vm.loadedFolders,
                    "loaded-videos": _vm.loadedVideos,
                    "single-select": _vm.singleSelect,
                    "loading-videos": _vm.loadingVideos,
                    "v2-only": _vm.v2Only,
                  },
                  on: { update: _vm.update, add: _vm.add },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.singleSelect
              ? _c(
                  "div",
                  {
                    staticClass:
                      "t-modal__footer t-pad--t-sm t-pad--b-sm t-pad--l-st t-pad--r-st",
                  },
                  [
                    _c(
                      "t-button",
                      {
                        staticClass: "t-width--100 t-dis--blk",
                        attrs: {
                          size: "medium",
                          disabled: _vm.$isEmpty(_vm.selectedVideos),
                          loading: _vm.loading,
                          variant: "primary",
                        },
                        on: { click: _vm.add },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.actionText || _vm.$t("generic.button.add")
                            ) +
                            " →\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm.canShowUpload && _vm.tab === "upload"
        ? [
            _c("UploadVideoComponent", {
              attrs: {
                "is-import-mode": true,
                "header-title": _vm.headerTitle,
                "input-label": _vm.inputLabel,
                "input-placeholder": _vm.inputPlaceholder,
                "can-collect-title": _vm.canCollectTitle,
              },
              on: { "video-created": _vm.addUploadVideo },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }